import { Link } from 'react-router-dom';

interface ListingCardProps {
  id: string;
  title: string;
  price?: number;
  currency?: string;
  images: string[];
  user: {
    firstName: string;
    rating: number;
  };
  views: number;
  createdAt: string;
}

export default function ListingCard({
  id,
  title,
  price,
  currency = 'RUB',
  images,
  user,
  views,
  createdAt
}: ListingCardProps) {
  const formatPrice = (amount: number, curr: string) => {
    const symbols: Record<string, string> = {
      RUB: '₽',
      KZT: '₸',
      BYN: 'Br'
    };
    return `${amount.toLocaleString('ru-RU')} ${symbols[curr] || curr}`;
  };

  const formatDate = (date: string) => {
    const d = new Date(date);
    const now = new Date();
    const diff = now.getTime() - d.getTime();
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));

    if (days === 0) return 'Сегодня';
    if (days === 1) return 'Вчера';
    if (days < 7) return `${days} дн. назад`;
    return d.toLocaleDateString('ru-RU');
  };

  return (
    <Link to={`/listings/${id}`} className="block">
      <div className="card hover:opacity-90 transition-opacity">
        <div className="aspect-square rounded-lg bg-tg-theme-bg overflow-hidden mb-3">
          {images.length > 0 ? (
            <img
              src={images[0]}
              alt={title}
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-4xl text-tg-theme-hint">
              📷
            </div>
          )}
        </div>

        <h3 className="font-medium text-sm line-clamp-2 mb-2">{title}</h3>

        {price !== undefined && price !== null ? (
          <p className="text-lg font-bold text-tg-theme-button mb-2">
            {formatPrice(price, currency)}
          </p>
        ) : (
          <p className="text-lg font-bold text-tg-theme-link mb-2">Договорная</p>
        )}

        <div className="flex items-center justify-between text-xs text-tg-theme-hint">
          <span>
            ⭐️ {user.rating.toFixed(1)} • {user.firstName}
          </span>
          <span>👁 {views}</span>
        </div>

        <p className="text-xs text-tg-theme-hint mt-1">{formatDate(createdAt)}</p>
      </div>
    </Link>
  );
}
